import {observer} from 'mobx-react'
import Sheet from '../components/Sheet'
import Markdown from '../components/Markdown'
import CONTENT from '../stores/Content'

const Info = () => {

  return (
    <Sheet order={3} className="bg-rubber">
      {CONTENT.info ? (
        <div className="max padx4">
          <Markdown className="outerx8" convert={CONTENT.info.contactCopy} />
          <Markdown className="outerx8" convert={CONTENT.info.socialCopy} />
          <div className="outerx8">
            <h5>Project supported by:</h5>
            <div className="innerx4">
              {CONTENT.info.logos.map(({fields}, i) => (
                <div className="guttersx2 imgfix span-6" key={`logo-${i}`}>
                  <img src={fields.file.url} />
                </div>
              ))}
            </div>
          </div>
          <Markdown convert={CONTENT.info.credits} />
        </div>
      ) : null}
    </Sheet>
  )
}

export default observer(Info)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/Info.js